<template>
    <div>

        <el-card>
            <div class="ewmShow">
                <div class="qrCodePortUrl" id="qrCodePortUrl" ref="qrCodePortUrl"></div>
                <div style="text-align: center;">{{ port_name }}</div>
                <el-button type="primary" @click="copyUrl()" style="text-align: center;">复制URL</el-button>
            </div>
        </el-card>

    </div>
</template>
<script>

import QRCode from 'qrcodejs2'
export default {
    props: [
        //  已分配设备管理标记
        'port_name',
        'uid'
    ],
    data() {
        return {
            httpUrl: ''
            // 获取用户列表参数

        };
    },
    created() {

    },
    mounted() {
        this.showEwm()
    },
    methods: {
        copyUrl() {
            var that = this
            navigator.clipboard.writeText(this.httpUrl).then(function () {
                that.$message.success('复制成功！');
            })
        },
        showEwm() {
            this.creatQrCode(this.uid)
        },
        creatQrCode(macUid) {
            // https://test.pzeiot.com:802/img/xuanchuan.html
            var httpApi = window.sessionStorage.getItem('http_api')
            console.log(httpApi + '/img2/xuanchuan.html?C_type=saoma_port&type=1&mac_port_uid=' + macUid + '&pro_uid=1')
            var qrcode = new QRCode(this.$refs.qrCodePortUrl, {
                text: httpApi + '/img2/xuanchuan.html?C_type=saoma_port&type=1&mac_port_uid=' + macUid + '&pro_uid=1', // 需要转换为二维码的内容
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            this.httpUrl = httpApi + '/img2/xuanchuan.html?C_type=saoma_port&type=1&mac_port_uid=' + macUid + '&pro_uid=1'
        }
    }
}
</script>
<style lang="less" scoped>
.card_zhongduan {
    background: #f9f9f9;
    width: 100%;
}

.class_port {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}

.ewmShow {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
